module.exports = __webpack_public_path__ + "assets/img/bgc2.ca0333d1.png";